// Generated by CoffeeScript 1.11.1
(function() {
  var LayerInfo, LayerNameSource,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  LayerInfo = require('../layer_info');

  module.exports = LayerNameSource = (function(superClass) {
    extend(LayerNameSource, superClass);

    function LayerNameSource() {
      return LayerNameSource.__super__.constructor.apply(this, arguments);
    }

    LayerNameSource.shouldParse = function(key) {
      return key === 'lnsr';
    };

    LayerNameSource.prototype.parse = function() {
      return this.id = this.file.readString(4);
    };

    return LayerNameSource;

  })(LayerInfo);

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer_info/layer_name_source.js
// module id = 61
// module chunks = 0